import React, { useContext, useEffect, useState } from 'react'
import NavAtHome from '../../Components/Navigators/NavAtHome'
import styles from '../Users/EachUserWrapper.module.css'
import { Link, useParams } from 'react-router';
import { BASE_URL_API } from '../../References/URLs';
import AuthContext from '../../store/auth-context';
import { MdCalendarToday, MdCardGiftcard, MdFamilyRestroom, MdFilter, MdFilterAlt, MdPhoneInTalk, MdRefresh, MdSort } from 'react-icons/md';
import AllVisitsWrapper from '../../Components/Users/AllVisitsWrapper';
import AllLedgerTransactionsWrapper from '../../Components/Users/AllLedgerTransactionsWrapper';
import AllPurchaseCardsAtClientPage from '../../Components/Users/AllPurchaseCardsAtClientPage';
import AllFamilyMembers from '../../Components/Users/AllFamilyMembers';
import { BsInfoCircle, BsPhone, BsTelephone } from 'react-icons/bs';
import { IoCardSharp } from "react-icons/io5";
import { IoMdSettings } from "react-icons/io";
import { MdAccountBalanceWallet } from "react-icons/md";
import AccountSettings from '../../Components/Users/AccountSettings';
import ActiveStoreContext from '../../store/ActiveStoreContext';
import UserDetails from '../../Components/Users/UserDetails';
import ClientSpecialMoments from '../../Components/Users/ClientSpecialMoments';
import { ToastContainer } from 'react-toastify';



const initialsOf = (name) =>
    (name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase())
        .join('')

const EachUserWrapper = props => {
    let params = useParams();
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const clientIdentifier = params.clientIdentifier;
    // Tab lives in the URL (/user/:clientIdentifier/:activeTab) so a link
    // can deep-link straight into e.g. the Family or Special Moments tab
    // instead of always landing on Details.
    const activeTab = params.activeTab || 'details'
    const [clientDetails, setClientDetails] = useState(null)
    const [isFetchingClientDetails, setIsFetchingClientDetails] = useState(false)

    const getClientFullDetails = async () => {
        setIsFetchingClientDetails(true)
        const getClientFullDetailsResponse = await fetch(BASE_URL_API + "getClientFullDetails",
            {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier,
                    clientStoreRelationIdentifier: clientIdentifier
                })
            });

        if (!getClientFullDetailsResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getClientFullDetailsRespo = await getClientFullDetailsResponse.json();
            if (getClientFullDetailsRespo.status === 'success') {
                setClientDetails(getClientFullDetailsRespo.response[0])
            } else {
                if (getClientFullDetailsRespo.message === 'tokenExpired') {
                    authCtx.logout()
                } else {

                }
            }
            console.log(getClientFullDetailsRespo)
        }
        setIsFetchingClientDetails(false)
    }

    useEffect(() => {
        getClientFullDetails()
    }, [clientIdentifier, activeStore?.storeIdentifier])


    if (clientDetails === null) {
        return (
            <div className={styles.stateWrapper}>
                {isFetchingClientDetails ? (
                    <>
                        <MdRefresh size={18} className={styles.stateSpinner} />
                        <span>Loading client…</span>
                    </>
                ) : (
                    <span>No records available</span>
                )}
            </div>
        )
    }

    const TABS = [
        { key: 'details', label: 'Details', Icon: BsInfoCircle, iconSize: 17 },
        { key: 'family', label: 'Family', Icon: MdFamilyRestroom, iconSize: 19 },
        { key: 'cards', label: 'Cards', Icon: IoCardSharp, iconSize: 17 },
        { key: 'ledger', label: 'Ledger', Icon: MdAccountBalanceWallet, iconSize: 18 },
        { key: 'special-moments', label: 'Special Moments', Icon: MdCardGiftcard, iconSize: 18 },
        { key: 'settings', label: 'Settings', Icon: IoMdSettings, iconSize: 18 },
    ]

    return (
        <div className={styles.mainWrapper}>
            {/* <NavAtHome /> */}
            <ToastContainer  />
            <div className={styles.mainContainer}>
                <div className={styles.leftWrapper}>
                    <div className={styles.leftProfileSynop}>
                        <div className={styles.avatar}>{initialsOf(clientDetails?.client_name) || '?'}</div>
                        <div className={styles.profileInfo}>
                            <div className={styles.clientName}>
                                {clientDetails?.client_name?.toLowerCase()}
                            </div>
                            <div className={styles.profileChips}>
                                {clientDetails?.gender && (
                                    <span className={styles.chip}>{clientDetails.gender}</span>
                                )}
                                <span className={styles.chip}>
                                    <MdPhoneInTalk size={12} />&nbsp;{clientDetails?.mobile}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className={styles.subMenusWrapper}>
                        <div className={styles.tabsWrapper}>
                            {TABS.map(({ key, label, Icon, iconSize }) => (
                                <Link
                                    key={key}
                                    to={`/user/${clientIdentifier}/${key}`}
                                    className={activeTab === key ? styles.activeTab : styles.eachTab}
                                >
                                    <Icon size={iconSize} />
                                    {label}
                                </Link>
                            ))}
                        </div>
                        <div className={styles.tabContent}>
                            {activeTab === "details" && <UserDetails clientStoreRelationIdentifier={clientIdentifier} clientDetails={clientDetails} getClientFullDetails={getClientFullDetails} />}
                            {activeTab === "family" && <AllFamilyMembers clientStoreRelationIdentifier={clientIdentifier} />}
                            {activeTab === "ledger" && <AllLedgerTransactionsWrapper clientStoreRelationIdentifier={clientIdentifier} clientDetails={clientDetails} />}
                            {activeTab === "cards" && <AllPurchaseCardsAtClientPage clientStoreRelationIdentifier={clientIdentifier} />}
                            {activeTab === "special-moments" && <ClientSpecialMoments clientStoreRelationIdentifier={clientIdentifier} />}
                            {activeTab === "settings" && <AccountSettings clientStoreRelationIdentifier={clientIdentifier} />}
                        </div>

                    </div>
                </div>
                <div className={styles.rightWrapper}>
                    <AllVisitsWrapper
                        clientStoreRelationIdentifier={clientIdentifier}
                    />
                </div>
            </div>
        </div>
    )
}

export default EachUserWrapper